
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns63ee93f8403b49ef464ce4929b67ded6en from './en.yaml'
            i18n.addResourceBundle('en', '63ee93f8403b49ef464ce4929b67ded6', flattenObject(ns63ee93f8403b49ef464ce4929b67ded6en), true, true);
        
        export default '63ee93f8403b49ef464ce4929b67ded6';
    